const Sdata = {
  shopItems: [
    {
      id: 7,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/39000/38182/250X360/38182.png",
      name: "দেবযান",
      price: "180",
      discount: "25",
    },
    {
      id: 8,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/5000/4332/250X360/4332.png",
      name: "শ্রেষ্ঠ প্রেমের উপন্যাস - হুমায়ূন আহমেদ",
      price: "120",
      discount: "10",
    },
    {
      id: 9,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/329000/328373/250X360/328373.png",
      name: "নীলডুমুর",
      price: "200",
      discount: "50 ",
    },
    {
      id: 10,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/328000/327453/250X360/327453.png",
      name: "মন জোছনার কান্না",
      price: "999",
      discount: "10 ",
    },
    {
      id: 11,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/328000/327216/250X360/327216.png",
      name: "অপেক্ষা",
      price: "80",
      discount: "20 ",
    },
    {
      id: 12,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/329000/328769/250X360/328769.png",
      name: "স্ট্রেস ম্যানেজমেন্ট ",
      price: "400",
      discount: "20 ",
    },
    {
      id: 13,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/320000/319391/250X360/319391.png",
      name: "তানভীন সুইটি",
      price: "60",
      discount: "5 ",
    },
    {
      id: 14,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/326000/325096/250X360/325096.png",
      name: "অলসতা জীবনের শত্রু",
      price: "120",
      discount: "10",
    },
    {
      id: 15,
      cover:
        "https://d1jpltibqvso3j.cloudfront.net/images/product/328000/327714/250X360/327714.png",
      name: "যেভাবে জয়ী হতে হয়",
      price: "5",
      discount: "2",
    },
  ],
};
export default Sdata;
